import '../app/styles/main.scss';

import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RequireAuth } from '@/shared/lib';
import { Loading } from '@/shared/ui';

import { BaseLayout } from '../layouts/base-layout';
import { NormalizePathname } from './normalize-pathname';
import { privateRoutes, publicRoutes } from './routes.tsx';

const Routing = () => {
  return (
    <NormalizePathname>
      <Routes>
        {publicRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={<Suspense fallback={<Loading visible />}>{Component}</Suspense>}
          />
        ))}

        <Route
          element={
            <RequireAuth>
              <BaseLayout />
            </RequireAuth>
          }
        >
          {privateRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={<Suspense fallback={<Loading visible />}>{Component}</Suspense>}
            />
          ))}
        </Route>
      </Routes>
    </NormalizePathname>
  );
};

export default Routing;
